module.exports = __webpack_public_path__ + "static/media/remove.a66bf9fd.svg";